module.exports = __webpack_public_path__ + "img/dynamicProgramming.afdcf2b4.svg";